@if (authService.authCheckCompleted()) {
  <router-outlet></router-outlet>
  <!-- Temporary dialog to notify new users -->
  <dhp-welcome-dialog></dhp-welcome-dialog>
}
